import { render, staticRenderFns } from "./copySubmitBar.vue?vue&type=template&id=3b0ab3ed&scoped=true"
import script from "./copySubmitBar.vue?vue&type=script&lang=js"
export * from "./copySubmitBar.vue?vue&type=script&lang=js"
import style0 from "./copySubmitBar.vue?vue&type=style&index=0&id=3b0ab3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ab3ed",
  null
  
)

export default component.exports